import React, { useEffect } from "react";
import AOS from "aos";
import "bootstrap-icons/font/bootstrap-icons.css";
import "aos/dist/aos.css";

const Services = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);
    
    const services = [
        {
            id: 1,
            delay: 100,
            className: "item-cyan",
            
            icon: "bi bi-activity",
            title: "Student Profiling",
            description:
                "Driven professional with expertise in specific skill, committed to delivering impactful solutions and driving Career success.",
        },
        {
            id: 2,
            delay: 200,
            className: "item-orange",
            icon: "bi bi-broadcast",
            title: "Career Counseling",
            description:
                "Receive expert career guidance to align your skills with industry trends and make informed, successful career decisions.",
        },
        {
            id: 3,
            delay: 300,
            className: "item-teal",
            icon: "bi bi-easel",
            title: "Skill Development Programs",
            description:
                "Join skill development workshops focused on emerging fields like data science, AI, and digital marketing to enhance your expertise.",
        },
        {
            id: 4,
            delay: 400,
            className: "item-red",
            icon: "bi bi-bounding-box-circles",
            title: "Mock Interviews",
            description:
                "Practice with industry experts to enhance communication, boost confidence, and increase your chances of success in top companies.",
        },
        {
            id: 5,
            delay: 500,
            className: "item-indigo",
            icon: "bi bi-calendar4-week",
            title: "Internship Opportunities",
            description:
                "Explore top internship opportunities to gain real-world experience and accelerate your career development.",
        },
        {
            id: 6,
            delay: 600,
            className: "item-pink",
            icon: "bi bi-chat-square-text",
            title: "Job Market Insights",
            description:
                "Stay informed on job market trends and high-demand roles to strategically plan and advance your career.",
        },
    ];
    

    return (
        <section id="services" className="services section">
            {/* Section Title */}
            <div className="container section-title" data-aos="fade-up" data-aos-delay="100">
                <h2>Services</h2>
                <p>Check Our Services</p>
            </div>

            <div className="container">
                <div className="row gy-4">
                    {services.map((service) => (
                        <div
                            className="col-lg-4 col-md-6"
                            data-aos="fade-up"
                            data-aos-delay={service.delay}
                            key={service.id}
                        >
                            <div className={`service-item ${service.className} position-relative`}>
                                <i className={`${service.icon} icon`}></i>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                {/* <a href="#" className="read-more stretched-link">
                                    <span>Read More</span> <i className="bi bi-arrow-right"></i>
                                </a> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
